import Dispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes, StatTypes } from '../constants/CentricConstants';

import EventApi from '../server/EventApi';

const createSuccessHandler = (...actions) => (response) =>
    actions.forEach((action) => Dispatcher.dispatch({ type: action, data: response.data }));


const createErrorHandler = (...actions) => (response) =>
    actions.forEach((action) => Dispatcher.dispatch({ type: action, data: response.message }));

const _handleFormError = createErrorHandler(ActionTypes.FORM_SUBMIT_ERROR);
const _handleException = createErrorHandler(ActionTypes.API_EXCEPTION);

export default {

    getAll: function(params) {
        const handleSuccess = createSuccessHandler(ActionTypes.EVENT_LIST);
        const handleError = createErrorHandler(ActionTypes.EVENT_LIST_ERROR);

       return  EventApi.getAll(params)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    getById: (eventId) => {
        const types = {
            success: ActionTypes.EVENT_INFO,
            failure: ActionTypes.EVENT_INFO_ERROR,
        };
        return Dispatcher.dispatchAsync(EventApi.getById(eventId), types, {eventId});
    },

    listByUser: (userId, params) => {
        const types = {
            success:    ActionTypes.EVENT_LIST,
            failure:    ActionTypes.EVENT_LIST_ERROR
        };

        return Dispatcher.dispatchAsync(EventApi.listByUser(userId, params), types, {userId, params});
    },

    save: function(entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.EVENT_SAVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.EVENT_INFO_ERROR);

        return EventApi.save(entity)
            .then(handleSuccess, _handleFormError);
    },
    update: function(id, entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.EVENT_UPDATE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.EVENT_UPDATE_ERROR);

        return EventApi.update(id, entity)
            .then(handleSuccess, _handleFormError)
            .catch(handleError);
    },
    delete: (id) => {
        const types = {
            success: ActionTypes.EVENT_DELETE,
            failure: [ActionTypes.EVENT_DELETE_ERROR, ActionTypes.FORM_SUBMIT_ERROR]
        };
        return Dispatcher.dispatchAsync(EventApi.delete(id), types, {id});
    },
    deletePeriodicInstance: (id) => {
        const types = {
            success: ActionTypes.EVENT_DELETE,
            failure: ActionTypes.EVENT_DELETE_ERROR
        };
        return Dispatcher.dispatchAsync(EventApi.deletePeriodicInstance(id), types, {id});
    },
    deletePeriodicWithFollowingInstances: (id) => {
        const types = {
            success: ActionTypes.EVENT_DELETE,
            failure: ActionTypes.EVENT_DELETE_ERROR
        };
        return Dispatcher.dispatchAsync(EventApi.deletePeriodicWithFollowingInstances(id), types, {id});
    },
    deletePeriodicAllInstances: (id) => {
        const types = {
            success: ActionTypes.EVENT_DELETE,
            failure: ActionTypes.EVENT_DELETE_ERROR
        };
        return Dispatcher.dispatchAsync(EventApi.deletePeriodicAllInstances(id), types, {id});
    },
    search: (searchText, params) => {
        const types = {
            request: ActionTypes.SEARCH_REQUEST,
            success: [ActionTypes.SEARCH_SUCCESS, ActionTypes.EVENT_LIST],
            failure: ActionTypes.SEARCH_FAILURE
        };

        return Dispatcher.dispatchAsync(EventApi.search(searchText, params), types, {searchText, params});
    },
    getStatusOptions: function() {
        const handleSuccess = createSuccessHandler(ActionTypes.EVENT_STATUS_OPTION_LIST);
        const handleError = createErrorHandler(ActionTypes.EVENT_INFO_ERROR);

        return EventApi.getStatusOptions()
            .then(handleSuccess, handleError)
            .catch(handleError);
    },
    getTypeOptions: function() {
        const handleSuccess = createSuccessHandler(ActionTypes.EVENT_TYPE_OPTION_LIST);
        const handleError = createErrorHandler(ActionTypes.EVENT_INFO_ERROR);

        return EventApi.getTypeOptions()
            .then(handleSuccess, handleError)
            .catch(handleError);
    },
    bookUsers: function(id, userIds) {
        const handleSuccess = createSuccessHandler(ActionTypes.EVENT_BOOK, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.FORM_SUBMIT_ERROR);

        return EventApi.bookUsers(id, userIds)
            .then(handleSuccess, _handleFormError)
            .catch(handleError);
    },
    getAttendees: function(eventId, options) {
        const types = {
            request:    ActionTypes.EVENT_ATTENDEE_LIST_REQUEST,
            success:    ActionTypes.EVENT_ATTENDEE_LIST_SUCCESS,
            failure:    ActionTypes.EVENT_ATTENDEE_LIST_FAILURE
        };

        return Dispatcher.dispatchAsync(EventApi.getAttendees(eventId, options), types, {eventId, role: 'delegate', options});
    },
    searchAttendees: (eventId, searchText, params) => {
        const types = {
            request: ActionTypes.SEARCH_REQUEST,
            success: ActionTypes.SEARCH_SUCCESS,
            failure: ActionTypes.SEARCH_FAILURE
        };
        return Dispatcher.dispatchAsync(EventApi.getAttendees(eventId, {searchText, ...params}), types, {eventId, searchText, params});
    },

    getMyAttendance: function(eventId) {
        const types = {
            request:    ActionTypes.EVENT_ATTENDEE_INFO_REQUEST,
            success:    ActionTypes.EVENT_ATTENDEE_INFO_SUCCESS,
            failure:    ActionTypes.EVENT_ATTENDEE_INFO_FAILURE
        };

        return Dispatcher.dispatchAsync(EventApi.getMyAttendance(eventId), types);
    },
    addMyAttendance: function(eventId) {
        // TODO: update these
        const types = {
            request:    ActionTypes.EVENT_ATTENDEE_INFO_REQUEST,
            success:    [ActionTypes.EVENT_ATTENDEE_INFO_SUCCESS, ActionTypes.FORM_SUBMIT_SUCCESS],
            failure:    ActionTypes.EVENT_ATTENDEE_INFO_FAILURE
        };

        return Dispatcher.dispatchAsync(EventApi.addMyAttendance(eventId), types);
    },

    removeMyAttendance: function(eventId, current) {
        const types = {
            request:    ActionTypes.EVENT_ATTENDEE_DELETE_REQUEST,
            success:    ActionTypes.EVENT_ATTENDEE_DELETE_SUCCESS,
            failure:    ActionTypes.EVENT_ATTENDEE_DELETE_FAILURE
        };
        return Dispatcher.dispatchAsync(EventApi.removeMyAttendance(eventId), types, {eventId, current});
    },

    getAttendance: (eventId, userId) => {
        const types = {
            request:    ActionTypes.EVENT_ATTENDEE_INFO_REQUEST,
            success:    ActionTypes.EVENT_ATTENDEE_INFO_SUCCESS,
            failure:    ActionTypes.EVENT_ATTENDEE_INFO_FAILURE
        };

        return Dispatcher.dispatchAsync(EventApi.getAttendanceDetails(eventId, userId), types, {eventId, userId});
    },

    addAttendance: (eventId, draft) => {
        const types = {
            request:    ActionTypes.EVENT_ATTENDEE_ADD_REQUEST,
            success:    ActionTypes.EVENT_ATTENDEE_ADD_SUCCESS,
            failure:    [ActionTypes.EVENT_ATTENDEE_ADD_FAILURE, ActionTypes.FORM_SUBMIT_ERROR]
        };

        return Dispatcher.dispatchAsync(EventApi.addAttendee(eventId, draft), types, {eventId, draft});
    },

    changeAttendanceStatus: (current, status) => {
        const types = {
            request:    ActionTypes.EVENT_ATTENDEE_SAVE_REQUEST,
            success:    ActionTypes.EVENT_ATTENDEE_SAVE_SUCCESS,
            failure:    ActionTypes.EVENT_ATTENDEE_SAVE_FAILURE
        };
        const newValue = Object.assign({}, current, {status});
        return Dispatcher.dispatchAsync(EventApi.changeAttendanceStatus(current.userId, current.eventId, status), types, {current, newValue});
    },
    removeAttendance: (current) => {
        const types = {
            request:    ActionTypes.EVENT_ATTENDEE_DELETE_REQUEST,
            success:    ActionTypes.EVENT_ATTENDEE_DELETE_SUCCESS,
            failure:    ActionTypes.EVENT_ATTENDEE_DELETE_FAILURE
        };
        return Dispatcher.dispatchAsync(EventApi.removeAttendee(current.eventId, current.userId), types, {current});
    },

    saveAsset: function(id, asset) {
        const handleSuccess = createSuccessHandler(ActionTypes.EVENT_ASSET_SAVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.EVENT_ASSET_SAVE_ERROR, ActionTypes.FORM_SUBMIT_ERROR);

        return EventApi.saveAsset(id, asset)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },
    listAssets: (eventId) => {
        const types = {
            request:    ActionTypes.EVENT_ASSET_LIST_REQUEST,
            success:    ActionTypes.EVENT_ASSET_LIST_SUCCESS,
            failure:    ActionTypes.EVENT_ASSET_LIST_FAILURE
        };

        return Dispatcher.dispatchAsync(EventApi.listAssets(eventId), types, {eventId});
    },
    addAsset: (eventId, assetId) => {
        const types = {
            request:    ActionTypes.EVENT_ASSET_ADD_REQUEST,
            success:    ActionTypes.EVENT_ASSET_ADD_SUCCESS,
            failure:    ActionTypes.EVENT_ASSET_ADD_FAILURE
        };

        return Dispatcher.dispatchAsync(EventApi.addAsset(eventId, assetId), types, {eventId, assetId});
    },
    removeAsset: (eventId, assetId) => {
        const types = {
            request:    ActionTypes.EVENT_ASSET_REMOVE_REQUEST,
            success:    ActionTypes.EVENT_ASSET_REMOVE_SUCCESS,
            failure:    ActionTypes.EVENT_ASSET_REMOVE_FAILURE
        };

        return Dispatcher.dispatchAsync(EventApi.removeAsset(eventId, assetId), types, {eventId, assetId});
    },
    getReminder: (eventId, reminderId) => {
        const types = {
            request:    ActionTypes.EVENT_REMINDER_INFO_REQUEST,
            success:    ActionTypes.EVENT_REMINDER_INFO_SUCCESS,
            failure:    ActionTypes.EVENT_REMINDER_INFO_FAILURE
        };

        return Dispatcher.dispatchAsync(EventApi.getReminder(eventId, reminderId), types, {eventId, reminderId});
    },

    getReminders: function(eventId) {
        const handleSuccess = createSuccessHandler(ActionTypes.EVENT_REMINDER_LIST);
        const handleError = createErrorHandler(ActionTypes.EVENT_REMINDER_LIST_ERROR);

        return EventApi.getReminders(eventId)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },
    saveReminder: function(id, reminder) {
        const handleSuccess = createSuccessHandler(ActionTypes.EVENT_REMINDER_SAVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.EVENT_REMINDER_SAVE_ERROR, ActionTypes.FORM_SUBMIT_ERROR);

        return EventApi.saveReminder(id, reminder)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },
    removeReminder: function(obj) {
        const handleSuccess = createSuccessHandler(ActionTypes.EVENT_REMINDER_REMOVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.EVENT_REMINDER_REMOVE_ERROR, ActionTypes.FORM_SUBMIT_ERROR);

        return EventApi.removeReminder(obj.id, obj.reminderId)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    sendEmail: (eventId, subject, message, userList) => {
        const types = {
            request:    ActionTypes.EVENT_EMAIL_SEND_BULK_REQUEST,
            success:    ActionTypes.EVENT_EMAIL_SEND_BULK_SUCCESS,
            failure:    ActionTypes.EVENT_EMAIL_SEND_BULK_FAILURE
        };

        return Dispatcher.dispatchAsync(EventApi.sendEmail(eventId, subject, message, userList), types, {eventId, subject, message, userList});
    },

    getTrainersEvents: (data) => {
        const types = {
            success:    ActionTypes.EVENT_LIST,
            failure:    ActionTypes.EVENT_LIST_ERROR
        };
        return Dispatcher.dispatchAsync(EventApi.getTrainersEvents(data), types);
    },

    getTemplates: () => {
        const types = {
            success: ActionTypes.EVENT_LIST,
            failure: ActionTypes.EVENT_LIST_ERROR
        };

        return Dispatcher.dispatchAsync(EventApi.getTemplates(), types);
    },

    listNotifications: (eventId) => {
        const types = {
            request:    ActionTypes.EVENT_NOTIFICATION_LIST_REQUEST,
            success:    ActionTypes.EVENT_NOTIFICATION_LIST_SUCCESS,
            failure:    ActionTypes.EVENT_NOTIFICATION_LIST_FAILURE
        };

        return Dispatcher.dispatchAsync(EventApi.listNotifications(eventId), types, {eventId});
    }

};
